import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc, TcPerfilUsuarioEnum, EnumIdsTcPais } from '../../../core/_infrastructure/types/common';
import { DatePipe, Location, DecimalPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { EnumIdsTcEstadoSolicitud, EnumCodigosTwTcAcciones, EnumIdsTcSubTipoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { ProductosService } from './productos.service';
import { SolicitudProductosViewModel, TwEmbalajesViewModel } from './productos.types';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-embalajes-edit',
    templateUrl: './embalajes-edit.component.html',
})
export class EmbalajeEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    editTitle = 'Nuevo';
    esCanarias = false;
    esPredua = false;
    codigoSolicitud: string;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitud: number;
    campoObligatorio = true;

    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;

    listPais: Tc[];
    listPaisUe: Tc[];
    listTaric: Tc[];
    listEppo: Tc[];
    listUnidad: Tc[];

    IdPaisOrigen: number;

    esPaisCE = false;
    IdSolicitud: number;
    IdGrabador: number | null = null;

    solicitudProductos: SolicitudProductosViewModel;
    //producto: TProductoSolicitudViewModel;
    embalaje: TwEmbalajesViewModel;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;
    esClonada = false;
    laHeGrabadoYo = false;

    public isCollapsedDatosBasicos = false;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        private productoService: ProductosService,
        private _location: Location,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudProductos = new SolicitudProductosViewModel();
        //this.producto = new TProductoSolicitudViewModel();
        this.embalaje = new TwEmbalajesViewModel();
    }

    ngOnInit() {
        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getPaisesUe().subscribe(res => {
            this.listPaisUe = res;
        });
        this.productoService.getTaricEmbalaje().subscribe(result => {
            this.listTaric = result;
        });
        this.productoService.getEppoEmbalaje().subscribe(result => {
            this.listEppo = result;
        });

        this.createForm();

        const id = +this.activatedRoute.snapshot.params['id'];
        const idemb = +this.activatedRoute.snapshot.params['idemb'];

        this.IdSolicitud = id;
        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(id);

        //EDIT DE EMBALAJE
        if (idemb) {
            this.editMode = true;
            this.editTitle = 'Editar';

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitud', id.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.productoService.getEmbalaje(idemb).subscribe(result => {
                    this.embalaje = result;

                    this.productoService.getUnidadEmbalajeByIdTaric(this.embalaje.IdTaric).subscribe(result => {
                        this.listUnidad = result;
                    });

                    this.esPredua =
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_NORMAL_PREDUA ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRASLADO_PREDUA ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO_PREDUA ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO_PREDUA ||
                        this.embalaje.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS_PREDUA
                            ? true
                            : false;

                    this.IdEstadoSolicitud = this.embalaje.IdEstadoSolicitud;
                    this.codigoSolicitud = this.embalaje.Codigo;
                    this.tituloTipoSolicitud = this.embalaje.IdTipoSolicitudDescripcion;
                    this.tituloEstadoSolicitud = this.embalaje.IdEstadoSolicitudDescripcion;
                    this.codigoTipoSolicitud = this.embalaje.CodigoTipoSolicitud;

                    this.IdResultadoEnvioMuestrasLaboratorio = this.embalaje.IdResultadoEnvioMuestrasLaboratorio;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.embalaje.DescripcionIdResultadoEnvioMuestrasLaboratorio;

                    this.esClonada =
                        this.embalaje.TwSolicitudJerarquia != null &&
                        this.embalaje.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.updateForm();
                    this.esPaisCE = this.embalaje.IdPais == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
                    //Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.embalaje.IdEstadoSolicitud).Visible &&
                            this.laHeGrabadoYo;
                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.embalaje.IdEstadoSolicitud).Visible &&
                            this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                            this.embalaje.IdEstadoSolicitud,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                            this.embalaje.IdEstadoSolicitud,
                        ).Visible;
                    }

                    //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.embalaje.IdEstadoSolicitud, undefined, this.embalaje.IdSubTipoSolicitud!).Visible;
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.embalaje.IdEstadoSolicitud, undefined, this.embalaje.IdSubTipoSolicitud!).Visible;

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.disableControlsConsulta();
                    }
                    //SI ES RE-IMPORTACION
                    if (this.embalaje.EsReImportacion) {
                        this.tituloTipoSolicitud += ' - Re-Importación';
                    }
                    //SI ES PREVIA
                    if (this.embalaje.EsPrevia) {
                        if (
                            this.embalaje.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                            this.embalaje.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += ' - Previa';
                        }
                        //Si es PREVIA SIN CODIGO se eliminan validaciones
                        if (this.embalaje.Codigo == null) {
                            //this.RemoveValidationsPrevia();
                            this.campoObligatorio = false;
                        }
                    }
                });
            });
        } //FIN EDIT EMBALAJE

        //ALTA DE EMBALAJE
        else {
            //SI ES ALTA SOLO CARGO LA INFORMACIÓN PARA LOS ICONOS
            this.productoService.getSolicitudProductos(id).subscribe(result => {
                this.solicitudProductos = result;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductos.IdEstadoSolicitud,
                    undefined,
                    this.solicitudProductos.IdSubTipoSolicitud!,
                ).Visible;
                if (!this.habilitarGuardar) {
                    //metodo para deshabilitar los controles
                    this.disableControlsConsulta();
                }

                this.esPredua =
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_NORMAL_PREDUA ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRASLADO_PREDUA ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO_PREDUA ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO_PREDUA ||
                    this.solicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS_PREDUA
                        ? true
                        : false;

                this.IdEstadoSolicitud = this.solicitudProductos.IdEstadoSolicitud;
                this.codigoSolicitud = this.solicitudProductos.CodigoSolicitud;
                this.tituloTipoSolicitud = this.solicitudProductos.IdTipoSolicitudDescripcion;

                this.tituloEstadoSolicitud = this.solicitudProductos.IdEstadoSolicitudDescripcion;
                this.codigoTipoSolicitud = this.solicitudProductos.CodigoTipoSolicitud;

                this.IdResultadoEnvioMuestrasLaboratorio = this.embalaje.IdResultadoEnvioMuestrasLaboratorio;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.embalaje.DescripcionIdResultadoEnvioMuestrasLaboratorio;

                this.esClonada =
                    this.solicitudProductos.TwSolicitudJerarquia != null &&
                    this.solicitudProductos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES RE-IMPORTACION
                if (this.solicitudProductos.EsReImportacion) {
                    this.tituloTipoSolicitud += ' - Re-Importación';
                }
                //SI ES PREVIA
                if (this.solicitudProductos.EsPrevia) {
                    if (
                        this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += ' - Previa';
                    }
                    //Si es PREVIA SIN CODIGO se eliminan validaciones
                    if (this.solicitudProductos.CodigoSolicitud == null) {
                        //this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                }
            });
        } //FIN DE ALTA DE EMBALAJE

        //Contenedores, abrimos solo el primero
        this.isCollapsedDatosBasicos = false;
    }

    private guardRefreshPage(id: number): void {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    //private RemoveValidationsPrevia() {
    //    this.removeValidators("NumeroDeclaracionSumaria");
    //}

    private disableControlsConsulta() {
        this.form.controls['IdTaric'].disable();
        this.form.controls['IdEppo'].disable();
        this.form.controls['IdUnidad'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['Recuento'].disable();
        this.form.controls['IdPaisReImportacion'].disable();
    }

    private createForm(): void {
        this.form = this.fb.group({
            IdTaric: [null, Validators.required],
            IdEppo: [null, Validators.required],
            IdUnidad: [null, Validators.required],
            IdPais: [null, Validators.required],
            Recuento: [null, Validators.required],
            IdPaisReImportacion: null,
        });
    }

    private updateForm(): void {
        this.form.setValue({
            IdTaric: this.embalaje.IdTaric,
            IdEppo: this.embalaje.IdEppo,
            IdUnidad: this.embalaje.IdUnidad,
            IdPais: this.embalaje.IdPais,
            Recuento: this.embalaje.Recuento,
            IdPaisReImportacion: this.embalaje.IdPaisReImportacion,
        });
    }

    onSaveEmbalaje(): void {
        this.visibilitySpinner = true;
        this.onSubmit();
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos del embalaje');

            this.isCollapsedDatosBasicos = false;

            return;
        }

        const embalaje = new TwEmbalajesViewModel();

        embalaje.IdTaric = this.form.value.IdTaric;
        embalaje.IdEppo = this.form.value.IdEppo;
        embalaje.IdUnidad = this.form.value.IdUnidad;
        embalaje.IdPais = this.form.value.IdPais;
        embalaje.Recuento = this.form.value.Recuento;
        embalaje.IdPaisReImportacion = this.form.value.IdPaisReImportacion;

        embalaje.IdSolicitud = this.IdSolicitud;
        embalaje.Id = this.embalaje.Id;

        if (this.editMode) {
            this.productoService.editEmbalaje(embalaje).subscribe({
                next: () => {
                    this.addSuccessMessage('Embalaje modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        } else {
            this.productoService.createEmbalaje(embalaje).subscribe({
                next: () => {
                    this.addSuccessMessage('Embalaje creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                },
            });
        }
    }

    onSelectPais(): void {
        const idPais = this.form.value.IdPais;
        this.esPaisCE = idPais == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
        if (this.esPaisCE) {
            this.addValidator('IdPaisReImportacion', Validators.required);
        } else {
            this.form.patchValue({
                IdPaisReImportacion: null,
            });
            this.removeValidators('IdPaisReImportacion');
        }
    }

    onSelectTaric() {
        const idTaric = this.form.value.IdTaric;

        this.productoService.getUnidadEmbalajeByIdTaric(idTaric).subscribe(result => {
            this.listUnidad = result;
        });

        this.form.patchValue({
            IdUnidad: null,
        });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/productos', this.IdSolicitud]);
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        //this._location.back();
    }
}
